// extracted by mini-css-extract-plugin
export default {"wrapper":"xaZvle_","border":"rGPIJOR","full":"ncme3mS","title":"Ba7TyKU","titleIcon":"j8QtrJk"};